// A hack for the Power Point Add-in

// The reason is the Power Point Add-in doesn't support history.pushState() and history.replaceState()
// Ideally, we just need to change the vue-router mode from 'history' to hash 'mode'
// But our presenter app has been using history mode for a long time, and we add so many conditions to handle those redirect edge cases.
// (Which I assume It's not the proper way to do it)
// So I just use this hack to simulate the redirect action.

import { mapActions, mapGetters } from 'vuex'
import Config from '@/config'

export default {
  computed: {
    ...mapGetters('redirectModule', ['urlQueryParams']),
    queryParams() {
      if (Config.isEnableAddinPowerpoint) {
        return this.urlQueryParams
      }
      return this.$route.query
    },
  },
  methods: {
    ...mapActions('redirectModule', ['setRedirectStoreAction']),
    redirectTo(redirectObject) {
      if (Config.isEnableAddinPowerpoint) {
        this.setRedirectStoreAction(redirectObject)
        return
      }
      this.$router.push(redirectObject)
    },
  },
}
